import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronMinimizeDiagonal2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.75,9.5h-4.5c-.414,0-.75,.336-.75,.75v4.5c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-3.75h3.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M7.75,2.5c-.414,0-.75,.336-.75,.75v3.75H3.25c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75H7.75c.414,0,.75-.336,.75-.75V3.25c0-.414-.336-.75-.75-.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconChevronMinimizeDiagonal2Fill18.js.map